// Slider for step 1
jQuery(document).ready(function ($) {
    if ($('.subscription-step-brew-slider').length) {
        var $slider = $('.subscription-step-brew-slider');

        $slider.slick({
            infinite: true,          // Loop through the carousel infinitely
            slidesToShow: 4,         // Show 4 items per slide
            slidesToScroll: 1,       // Scroll 1 item at a time
            arrows: true,            // Show next/prev arrows
            prevArrow: $('.subscription-step-brew-slider-arrow-prev'),
            nextArrow: $('.subscription-step-brew-slider-arrow-next'),
            swipe: false,
            responsive: [
                {
                    breakpoint: 1200,    
                    settings: {
                        slidesToShow: 3   
                    }
                },
                {
                    breakpoint: 1024,    
                    settings: {
                        slidesToShow: 2   
                    }
                },
                {
                    breakpoint: 720,     
                    settings: "unslick"  // Disable slick at 720px and below
                }
            ]
        });

        // Reinitialize Slick when resizing above 720px
        $(window).on('resize', function () {
            if ($(window).width() > 720 && !$slider.hasClass('slick-initialized')) {
                $slider.slick({
                    infinite: true,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: $('.subscription-step-brew-slider-arrow-prev'),
                    nextArrow: $('.subscription-step-brew-slider-arrow-next'),
                    swipe: false,
                    responsive: [
                        { breakpoint: 1200, settings: { slidesToShow: 3 } },
                        { breakpoint: 1024, settings: { slidesToShow: 2 } }
                    ]
                });
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    
    // Attach event listener to the body or a parent element
    document.body.addEventListener('click', function (event) {
        // Check if the clicked element is inside a .box-item, even if it's a child
        let boxItem = event.target.closest('.box-item');

        const productAtcElement = document.getElementById('subscription-button');
        
        if (boxItem) {
            let subscriptionWrapper = boxItem.closest('.subscription-step');

            if (subscriptionWrapper) {
                // Remove the active class from all .box-item elements inside this wrapper
                subscriptionWrapper.querySelectorAll('.box-item').forEach(function (box) {
                    box.classList.remove('box-item--active');
                });
    
                // Add the active class to the clicked box-item
                boxItem.classList.add('box-item--active');
            }

            // Add active class to the clicked box-item
            boxItem.classList.add('box-item--active');

            // Call the subscriptionProductSelect function if required attributes are present
            if (boxItem.hasAttribute('data-product-id') && boxItem.hasAttribute('data-product-handle')) {
                subscriptionProductSelect(boxItem);

                // we should not remove 'data-quantity'
                ['data-variant-id', 'data-selling-plan-id'].forEach(attr => {
                    productAtcElement.removeAttribute(attr);
                });

                

                productAtcElement.setAttribute('disabled', 'disabled');
                productAtcElement.classList.add('disabled');
            }

            // Set attributes on the productAtcElement if they exist on the clicked .box-item
            if (boxItem.hasAttribute('data-variant-id')) {
                productAtcElement.setAttribute('data-variant-id', boxItem.getAttribute('data-variant-id'));
            
                // Fetch variant price and update item prices
                const variantId = boxItem.getAttribute('data-variant-id');
                fetch(`/variants/${variantId}.js`)
                    .then(response => {
                        if (!response.ok) throw new Error("Failed to fetch variant data");
                        return response.json();
                    })
                    .then(variantData => {
                        console.table(variantData);
                        const originalPrice = (variantData.price) / 100 ; // Convert cents to dollars                        
                        const items = document.querySelectorAll('.items-quantity-selector .items-quantity-selector__item');
                        //const images = document.querySelectorAll('.items-quantity-selector .items-quantity-selector__item-image');
                        const originalPrices = document.querySelectorAll('.items-quantity-selector .items-quantity-selector__item-original-price');
                        const prices = document.querySelectorAll('.items-quantity-selector .items-quantity-selector__item-price');
                        const subscriptionItemDiscount = 3; // Discount for each subscription item
                        

                        items.forEach((item, index) => {
                            //const imageElement = images[index];
                            //imageElement.src = variantData.featured_image.src;
                            //imageElement.style.display = 'block';

                            const priceElement = prices[index];
                            const originalPriceElement = originalPrices[index];
                            const adjustedPrice = Math.max(originalPrice - index - subscriptionItemDiscount, 0); // Ensure price doesn't go below 0
                            //adjustedPrice -= 3; // Apply discount
                            //const adjustedOriginalPrice = Math.max(originalPrice - index, 0) ; // Ensure price doesn't go below 0
                            adjustedOriginalPrice = originalPrice;
                            
                            originalPriceElement.textContent = `$${adjustedOriginalPrice.toFixed(2)}`;
                            originalPriceElement.style.display = 'block';
                            
                            priceElement.textContent = `$${adjustedPrice.toFixed(2)} / each`; // Format price
                            priceElement.style.display = 'block';
                        });
                        
                    })
                    .catch(error => {
                        console.error("Error fetching variant data:", error);
                    });
            }
            

            if (boxItem.hasAttribute('data-quantity')) {
                productAtcElement.setAttribute('data-quantity', boxItem.getAttribute('data-quantity'));
            }

            if (boxItem.hasAttribute('data-selling-plan-id')) {
                productAtcElement.setAttribute('data-selling-plan-id', boxItem.getAttribute('data-selling-plan-id'));
            }

            if (['data-variant-id', 'data-quantity', 'data-selling-plan-id'].every(attr => productAtcElement.hasAttribute(attr))) {
                productAtcElement.removeAttribute('disabled');
                productAtcElement.classList.remove('disabled');
            }
            
        }
        
        // if(event.target.hasAttribute("data-product-atc")){
        //     //defined in assets/side-cart.js
        // }
        
    });


    // Now, let's select some product
    document.querySelectorAll('[data-product-id="7075459498087"]')[1].click();

    
    
    
});






// // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //  
async function subscriptionProductSelect(boxItem) {

    // Hide quantity selector price and image
    // Why I am not using jQuery...
    // Select all item image and item price elements
    const itemImages = document.querySelectorAll('.items-quantity-selector .items-quantity-selector__item-image');
    const itemPrices = document.querySelectorAll('.items-quantity-selector .items-quantity-selector__item-price');

    // Hide item images
    itemImages.forEach(image => {
    image.style.display = 'none';
    });

    // Hide item prices
    itemPrices.forEach(price => {
    price.style.display = 'none';
    });



    // Retrieve the product handle from the clicked product box
    const productHandle = boxItem.dataset.productHandle;
    try {
        // Fetch product data using Shopify's endpoint for product data in JSON format
        const response = await fetch(`/products/${productHandle}.json`);
        if (!response.ok) {
            throw new Error("Failed to fetch product data");
        }
        const data = await response.json();

        // Display variants in the .subscription-step-format-inner block
        const variantsContainer = document.querySelector('.subscription-step-format-inner');
        variantsContainer.innerHTML = ""; // Clear previous variants

        data.product.variants.forEach(variant => {

            // Create the subscription-step-format-item div
            const variantEl = document.createElement('div');
            variantEl.classList.add('subscription-step-format-itembox-item', 'box-item');
            variantEl.setAttribute('data-variant-id', variant.id); // Add data-variant-id

            // Create the image element and set the src (you can adjust this to show the variant image)
            const img = document.createElement('img');
            img.classList.add('subscription-step-format-item-image');

            // img.src = "https://cdn.shopify.com/s/files/1/0570/8359/2807/files/whole-bean.jpg?v=1731978395";
            // var description_text = "For the freshest coffee experience.";
            // if(variant.title == "Ground"){
            //     img.src = "https://cdn.shopify.com/s/files/1/0570/8359/2807/files/ground-coffee.jpg?v=1731978394";  
            //     description_text = "For ultimate convenience.";                
            // }

            switch (variant.title) {
                case "Whole Beans":
                    img.src = "https://cdn.shopify.com/s/files/1/0570/8359/2807/files/Fresh-beans.png?v=1744239315";
                    description_text = "Grind fresh at home";
                    break;
                case "Medium Grind":
                    img.src = "https://cdn.shopify.com/s/files/1/0570/8359/2807/files/Medium-Grind-Ground_a56a2fa2-7436-4475-9b67-25d31f8e0291.png?v=1744246748";
                    description_text = "Drip & pour-over";
                    break;
                case "Pod Grind":
                    img.src = "https://cdn.shopify.com/s/files/1/0570/8359/2807/files/Pods-grind-coffee.png?v=1744239477";
                    description_text = "For reusable pods";
                    break;
                case "Espresso Grind":
                    img.src = "https://cdn.shopify.com/s/files/1/0570/8359/2807/files/Espresso-Fine-grind.png?v=1744239221";
                    description_text = "Fine grind for espresso";
                    break;
                default:
                    img.src = "https://cdn.shopify.com/s/files/1/0570/8359/2807/files/whole-bean.jpg?v=1731978395";
                    description_text = "Grind fresh at home";
            }

            //img.src = variant.image ? variant.image.src : '/path/to/default/image.jpg'; // Default image if no variant image
            variantEl.appendChild(img);

            // Create and set the title
            const title = document.createElement('div');
            title.classList.add('subscription-step-format-item-title');
            title.textContent = variant.title; // The variant title (e.g., size or color)
            variantEl.appendChild(title);

            // Create and set the description (this can be any additional information you want)
            const description = document.createElement('div');
            description.classList.add('subscription-step-format-item-description');
            description.textContent = variant.sku || 'No description available'; // Example: SKU as description

            
            description.textContent = description_text;
            
            variantEl.appendChild(description);

            // Create and set the price
            // const price = document.createElement('div');
            // price.classList.add('subscription-step-format-item-price');
            // price.textContent = `$${(variant.price)}`; // Format price to dollars
            // variantEl.appendChild(price);

            // Append the variant item to the variants container
            variantsContainer.appendChild(variantEl);
        });

        

        // Fetch and display subscription frequencies from selling_plan_groups
        const frequenciesContainer = document.querySelector('.subscription-step-frequency-inner');
        frequenciesContainer.innerHTML = ''; // Clear previous subscription frequencies

        const frequencyResponse = await fetch(`/products/${productHandle}.js`);
        if (!frequencyResponse.ok) {
            throw new Error("Failed to fetch frequencies");
        }
        const frequencyData = await frequencyResponse.json();

        const sellingPlanGroups = frequencyData.selling_plan_groups;


        // Check if the product has subscription frequencies in selling_plan_groups
        if (frequencyData.selling_plan_groups && frequencyData.selling_plan_groups.length > 0) {

            // Loop through selling plan groups and display them
            sellingPlanGroups.forEach(group => {
                // Assuming each group has plans with interval_count and price

                let intervalCount = 1; // Initialize intervalCount outside the loop

                group.selling_plans.forEach(plan => {
                    console.log(plan);
                    const frequencyItem = document.createElement('div');
                    frequencyItem.classList.add('subscription-frequency-item', 'box-item');
                    frequencyItem.setAttribute('data-selling-plan-id', plan.id); // Add data-variant-id


                    // Frequency label (e.g., "Every X weeks")
                    const labelEvery = document.createElement('div');
                    labelEvery.classList.add('subscription-frequency-item-label-every');
                    labelEvery.textContent = `Every`;
                    frequencyItem.appendChild(labelEvery);

                    // Frequency value (e.g., price)
                    const value = document.createElement('div');
                    value.classList.add('subscription-frequency-item-value');
                    const number = Array.from(plan.options[0].value);
                    value.textContent = number[0] ? number[0] : ' ';
                    frequencyItem.appendChild(value);

                    // Frequency weeks/months
                    const weeks = document.createElement('div');
                    weeks.classList.add('subscription-frequency-item-weeks');
                    //weeks.textContent = `${plan.interval_count} ${plan.interval === 'week' ? 'week' : 'month'}${plan.interval_count > 1 ? 's' : ''}`;
                    //weeks.textContent = 'week';
                    //weeks.textContent = `${plan.interval_count > 1 ? 'weeks' : 'week'}`; // Adjust text based on count

                    weeks.textContent = intervalCount > 1 ? 'weeks' : 'week'; // Pluralize based on intervalCount

                    frequencyItem.appendChild(weeks);

                    // Append the frequency item to the container
                    frequenciesContainer.appendChild(frequencyItem);

                    intervalCount++; // Increment intervalCount
                });
            });
        } else {
            console.log('No subscription frequencies found for this product');
        }

    } catch (error) {
        console.error("Error fetching product data:", error);
    }

    document.querySelectorAll('.subscription-step-format-itembox-item')[0].click();
    document.querySelectorAll('.items-quantity-selector__item')[2].click();
    document.querySelectorAll('.subscription-frequency-item')[1].click();

}